import config from "@/config";
import { buildStatsQueryParams } from "@/lib/dashboard-api";
import type { CaseRecord, DashboardStatsQuery } from "@/types";

/**
 * Load case documents matching the dashboard URL filters (same semantics as stats/charts).
 */
export async function fetchCasesForDashboardExport(
  query: DashboardStatsQuery,
): Promise<{ cases: CaseRecord[]; truncated: boolean }> {
  const params = buildStatsQueryParams(query);
  const qs = params.toString();
  const url = `${config.API_BASE_URL}/api/dashboard/export-cases${qs ? `?${qs}` : ""}`;
  const res = await fetch(url);
  if (!res.ok) {
    const raw = await res.text();
    let detail = raw;
    try {
      const body = JSON.parse(raw) as { detail?: unknown };
      if (typeof body.detail === "string") {
        detail = body.detail;
      } else if (typeof body.detail === "object" && body.detail !== null) {
        detail = JSON.stringify(body.detail);
      } else {
        detail = raw;
      }
    } catch {
      /* not JSON; use raw */
    }
    throw new Error(detail || `Export failed (${res.status})`);
  }
  const data = (await res.json()) as {
    cases?: Record<string, unknown>[];
    truncated?: boolean;
  };
  const mapped = (data.cases ?? []).map((c) => ({
    ...c,
    id: String(c.document_id ?? c.id ?? ""),
  })) as CaseRecord[];
  return { cases: mapped, truncated: Boolean(data.truncated) };
}
